import Navbar from '../../components/feature/Navbar';
import Members from '../home/components/Members';
import Footer from '../home/components/Footer';

export default function MembersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Hero */}
      <section className="relative h-[300px] sm:h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/72f3377a6e22419cf923cd9d739ec468.jpg"
          alt="會員名冊"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
        <div className="relative h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 pt-16 sm:pt-20 w-full">
          <p className="text-xs font-light text-stone-300 tracking-widest uppercase mb-2 sm:mb-3">Our Members</p>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-white leading-tight mb-3 sm:mb-6 drop-shadow-lg">
            會員名冊
          </h1>
          <p className="text-sm sm:text-base lg:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
            YMC Taipei 匯聚各行各業的精英企業家，超過 500 位活躍會員共同組成這個充滿活力的青年企業家大家庭。
          </p>
        </div>
      </section>

      {/* Members Section */}
      <Members />

      <Footer />
    </div>
  );
}
